import { Subject } from 'rxjs';
import { BehaviorSubject } from 'rxjs';

export class CurvaAbcVendaFilterInitialization {
    private main: boolean;
    private referencia: boolean;
    initialization = new Subject<boolean>();
    initializing = new BehaviorSubject<boolean>(true);
    initialized = new BehaviorSubject<boolean>(false);

    constructor() {
        this.main = false;
        this.referencia = false;
        this.init();
    }

    private init() {
        this.initialization.subscribe(
            isInitialized => {
                if (isInitialized) {
                    this.initializing.next(false);
                    this.initializing.complete();

                    this.initialized.next(true);
                    this.initialized.complete();
                }
            }
        );
    }

    isInitialized(): boolean {
        return this.main && this.referencia;
    }

    initializeMain() {
        this.main = true;
        this.initialization.next(this.isInitialized());
    }

    initializeReferencia() {
        this.referencia = true;
        this.initialization.next(this.isInitialized());
    }
}
